/**
 * Firebase events
 */

const FIREBASE_EVENTS = Object.freeze({
    pageView: 'page_view',
    deployStart: 'deploy_start',
    deployEnd: 'deploy_end',
    dataProductDeployStart: 'data_product_deploy_start',
    dataProductDeployEnd: 'data_product_deploy_end',
})

export default FIREBASE_EVENTS